/**
 * Maps WebSocket payload changes into the shape expected by the slice.
 *
 * @param {Object} [changes]
 * @returns {Object | null}
 */
export const mapSanitizedChanges = (changes) => {
	if (!changes || !Object.keys(changes).length) return null;

	const mappedChanges = { ...changes };

	if (changes.effective_starting_bid_amount !== undefined) {
		mappedChanges.price = changes.effective_starting_bid_amount;
	}

	if (changes.floor_price !== undefined) {
		mappedChanges.floor_price = changes.floor_price;
	}

	return mappedChanges;
};

/**
 * Builds a normalized error message from a bulk edit update response.
 *
 * @param {Object} updateResult
 * @param {string} [fallbackMessage]
 * @returns {string | undefined}
 */
export const getBulkEditUpdateErrorMessage = (updateResult, fallbackMessage) => {
	if (updateResult?.success) return undefined;

	const errorMessages = Array.isArray(updateResult?.errors) ? updateResult.errors.filter(Boolean) : [];

	if (errorMessages.length) return errorMessages.join(' ');

	if (typeof updateResult?.message === 'string' && updateResult.message.trim()) {
		return updateResult.message;
	}

	if (Array.isArray(updateResult?.messages)) {
		const messages = updateResult.messages.filter(Boolean).join(' ');

		if (messages) return messages;
	}

	return fallbackMessage;
};
